import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

import { useOrganisationStore } from './organisations'

export const useUiStore = defineStore('ui', () => {
  const organisationStore = useOrganisationStore()

  const useFullScreenLayout = ref(false)
  const demoModeActivated = ref(false)
  // Developer/demo toggle. Keep false for the simplified client UX where each property has one
  // implicit planning scenario; set true locally to demo multi-scenario CRUD.
  const enableMultiplePlanningScenarios = ref(false)

  function setFullScreenLayout(useFullscreen: boolean) {
    useFullScreenLayout.value = useFullscreen
  }

  function reset() {
    useFullScreenLayout.value = false
    demoModeActivated.value = false
  }

  watch(
    () => organisationStore.currentOrgId,
    () => {
      reset()
    },
  )

  return {
    useFullScreenLayout,
    setFullScreenLayout,
    demoModeActivated,
    enableMultiplePlanningScenarios,
    reset,
  }
})
